import React, { ReactNode, useEffect, useState } from 'react';
import styled from 'styled-components';
import { gql, useQuery } from '@apollo/client';
import { Link } from 'react-router-dom';
import OrderStatus from 'Components/OrderStatus';
import { AnonymousOrder } from 'Components/Storage';
import { getHistoryOrder, getHistoryOrderVariables } from './__queries__';
import getTexts from 'Scenes/OrderStatus/utils/getTexts';
import { ORDER_STATUS } from 'Scenes/HistoryOrder/components';
import useI18n from 'i18n';
import getLocale from 'i18n/getLocale';

export const ANONYMOUS_ORDER_QUERY = gql`
  query getHistoryOrder($orderId: ID!) {
    Order(id: $orderId) {
      id
      desiredTime
      easyId
      status
      estimatedFinishTime
    }
  }
`;

const Wrapper = styled.div`
  position: relative;
`;

const OrderWrapper = styled(Link)``;

type Colors = {
  [key: string]: string;
};
const colors: Colors = {
  PENDING: '#314fee',
  ACCEPTED: '#ff8400',
  FINALIZING: '#ff8400',
  READY: '#209946',
  REJECTED: '#FF0000',
};

interface Props {
  orderId: string;
  venueId: string;
  anonymousOrder: AnonymousOrder;
}

const Orders = ({ orderId, venueId, anonymousOrder }: Props) => {
  const [color, setColor] = useState('');
  const { i18n } = useI18n();
  const locale = getLocale();
  const { data } = useQuery<getHistoryOrder, getHistoryOrderVariables>(ANONYMOUS_ORDER_QUERY, {
    variables: {
      orderId: orderId,
    },
    pollInterval: 5000,
    fetchPolicy: 'network-only',
  });
  const order = data?.Order;

  const getOrderTexts = (): { statusText: string; messageText: ReactNode } | undefined => {
    if (!order) return;
    return getTexts(
      {
        status: order.status,
        easyId: order.easyId,
        estimatedFinishTime: order.estimatedFinishTime,
      },
      i18n,
      locale,
    );
  };
  const orderTexts = getOrderTexts();

  useEffect(() => {
    if (!order) return;
    setColor(colors[order.status]);
  }, [data]);

  return (
    <Wrapper>
      {order && order.status !== ORDER_STATUS.COMPLETED && (
        <OrderWrapper to={`/order/${venueId}/order/${orderId}`}>
          <OrderStatus
            borderWidth={0}
            shadow={'0px 1px 32px 0px rgba(0, 0, 0, 0.32)'}
            background={'#fff'}
            messageColor={'rgb(97, 97, 100)'}
            statusColor={color}
            iconColor={color}
            top={8}
            status={orderTexts ? orderTexts.statusText : ''}
            message={orderTexts ? orderTexts.messageText : ''}
          />
        </OrderWrapper>
      )}
    </Wrapper>
  );
};

export default Orders;
